import { Boss } from './boss.js';

// Dedicated phase-1 boss script.
// Keeps phase selection out of callers so phase-1 and phase-2 can be spawned
// from separate entry points.
export class BossPhase1 extends Boss {
  constructor({ scene, x, z, audio, fbx }) {
    super({
      scene,
      x,
      z,
      audio,
      fbx,
      phase: 1,
    });
  }
}

